(function () {
  const GLOBAL_KEY = 'SootheWaitlistTurnstile';

  if (typeof window === 'undefined' || window[GLOBAL_KEY]) {
    return;
  }

  function loadTurnstileScript() {
    if (window.turnstile) {
      return Promise.resolve();
    }

    if (loadTurnstileScript.promise) {
      return loadTurnstileScript.promise;
    }

    loadTurnstileScript.promise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-soothe-turnstile]');

      if (existing) {
        existing.async = false;
        existing.defer = false;
        existing.addEventListener('load', () => resolve());
        existing.addEventListener('error', () => reject(new Error('Failed to load Turnstile.')));

        if (existing.dataset.loaded === 'true') {
          resolve();
        }

        return;
      }

      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.dataset.sootheTurnstile = 'true';
      script.async = false;
      script.defer = false;
      script.type = 'text/javascript';
      script.onload = () => {
        script.dataset.loaded = 'true';
        resolve();
      };
      script.onerror = () => reject(new Error('Failed to load Turnstile.'));
      document.head.appendChild(script);
    });

    return loadTurnstileScript.promise;
  }

  function createWidget(siteKey, container) {
    if (!siteKey) {
      throw new Error('Turnstile sitekey is required.');
    }

    if (!container) {
      throw new Error('Turnstile container is not available.');
    }

    let widgetId = null;
    let latestToken = null;
    let pendingResolvers = [];
    let mount = container.querySelector('[data-turnstile-mount]');

    if (!mount) {
      mount = document.createElement('div');
      mount.setAttribute('data-turnstile-mount', 'true');
      container.appendChild(mount);
    }

    const setActive = (state) => {
      if (!container || !container.classList) {
        return;
      }

      if (state) {
        container.classList.add('is-turnstile-active');
      } else {
        container.classList.remove('is-turnstile-active');
      }
    };

    setActive(false);

    const initPromise = loadTurnstileScript().then(
      () =>
        new Promise((resolve, reject) => {
          if (!window.turnstile || typeof window.turnstile.render !== 'function') {
            reject(new Error('Turnstile library unavailable.'));
            return;
          }

          window.turnstile.ready(() => {
            widgetId = window.turnstile.render(mount, {
              sitekey: siteKey,
              appearance: 'interaction-only',
              execution: 'execute',
              callback(token) {
                latestToken = token;
                setActive(false);
                const resolvers = pendingResolvers.slice();
                pendingResolvers = [];
                resolvers.forEach(({ resolve: resolveToken }) => resolveToken(token));
              },
              'error-callback'(errorCode) {
                console.error('Turnstile error:', errorCode);
                setActive(false);
                const resolvers = pendingResolvers.slice();
                pendingResolvers = [];
                resolvers.forEach(({ reject: rejectToken }) =>
                  rejectToken(new Error('Unable to verify you are human. Please try again.'))
                );

                if (widgetId !== null && window.turnstile) {
                  window.turnstile.reset(widgetId);
                }
              },
              'expired-callback'() {
                setActive(false);
                latestToken = null;
              }
            });

            resolve();
          });
        })
    );

    return {
      async getToken() {
        await initPromise;

        if (latestToken) {
          const token = latestToken;
          latestToken = null;
          return token;
        }

        return new Promise((resolve, reject) => {
          pendingResolvers.push({ resolve, reject });

          try {
            setActive(true);
            window.turnstile.execute(widgetId);
          } catch (error) {
            setActive(false);
            pendingResolvers = pendingResolvers.filter((entry) => entry.resolve !== resolve);
            reject(error);
          }
        });
      },
      reset() {
        latestToken = null;
        setActive(false);

        if (widgetId !== null && window.turnstile) {
          window.turnstile.reset(widgetId);
        }
      }
    };
  }

  window[GLOBAL_KEY] = {
    create(siteKey, container) {
      return createWidget(siteKey, container);
    }
  };

  if (typeof window.SootheWaitlistSuccess !== 'function') {
    window.SootheWaitlistSuccess = function onWaitlistSuccess() {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead');
      }
    };
  }
})();
